import { EMOJI_SETS } from '../EvaluationScaleConfig';

export const getImageUrl = item => {
  if (!item) return null;
  const img = item.imageUrl || item.image_url;
  if (!img) return null;
  return typeof img === 'string' ? img : img.fileUrl || img.file_url || null;
};

export const getMappedData = question => {
  if (question.responseFormat === 'points') {
    const results = question.results || [];
    return results.map(row => {
      let totalPoints = 0;
      if (Array.isArray(row.frequencies)) {
        totalPoints = row.frequencies.reduce((sum, f) => sum + Number(f.val) * Number(f.count), 0);
      } else if (row.frequencies && typeof row.frequencies === 'object') {
        totalPoints = Object.entries(row.frequencies).reduce(
          (sum, [val, count]) => sum + Number(val) * Number(count),
          0
        );
      }
      return {
        ...row,
        value: totalPoints
      };
    });
  }

  if (question.responseFormat !== 'emojis') return question.results || [];

  const sortedChoices = (question.questionChoicesAttributes || [])
    .filter(c => !c._destroy)
    .sort((a, b) => a.position - b.position);
  const n = sortedChoices.length;
  const emojis = EMOJI_SETS[n] || EMOJI_SETS[5];

  return (question.results || []).map(item => {
    if (item.name === 'Sin responder') return item;
    const choice = sortedChoices.find(c => {
      const nameStr = c.label || String(c.position);
      return nameStr === item.name;
    });
    const choiceIdx = choice ? sortedChoices.indexOf(choice) : -1;
    const emoji = choiceIdx !== -1 ? emojis[choiceIdx] : null;
    if (emoji) {
      return {
        ...item,
        name: `${emoji} ${item.name}`
      };
    }
    return item;
  });
};

export const getYDomain = question => {
  if (question.responseFormat === 'semantic_differential') {
    const choices = question.questionChoicesAttributes || [];
    const configChoice = choices.find(c => c.kind === 'config');
    const range = configChoice?.label || '-3a3';
    const parts = range.split('a');
    const min = parseInt(parts[0], 10);
    const max = parseInt(parts[1], 10);
    return [min, max];
  }
  if (['points', 'preference_order'].includes(question.responseFormat)) {
    return [0, 'auto'];
  }
  return ['auto', 'auto'];
};

export const capitalize = str => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};
